<script>
export default {
  methods: {
    nco (operation, _default) {
      try {
        let result = operation()
        return result !== null && result !== undefined ? result : _default
      } catch (e) {
        return _default
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/mixins/nullConditionalOperator.vue